import { DataBean } from "../DataBean";

export class TaxPosition extends DataBean {


    public async getTaxPositionCatalogPorPropiedades(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getTaxPositionCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }
    public async getTaxPositionRender(page: any, maxRows: any, properties: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getTaxPositionRender_Number_Number_java.util.Map", [page, maxRows, properties]);
    }

    public async importArancel(idEmployee: any, media: any, mediaContext: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "void_importArancel_Number_String_String", [idEmployee, media, mediaContext]);
    }


}